import styled from 'styled-components'

export const Stamp = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  height: 18px;
`

export const ZeroKm = styled.span`
  background-image: url('/assets/img/zero-km.svg');
  background-position: center center;
  background-repeat: no-repeat;
  width: 171px;
  height: 18px;
`
